// 3rd party imports
import * as React from 'react';

// ui
import { LocalizedText } from '@shared-ui/localization-context';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkFigure } from 'uitk-react-images';
import { UitkSecondaryButton, UitkButtonSize } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

// components
import { AffiliateCTA } from '../affiliate-cta';

// utils
import { useStores, useLocaleParam } from 'hooks';
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

function Hero() {
  const { analytics, userAuth, pzStore } = useStores();

  const { signinLink } = useLocaleParam();

  const trackSelect = (rfrr) => {
    const linkName = {
      'affhub_home_hero_sign_in.selected': 'AffHub Home Hero Sign In Selected',
      'affhub_home_hero_join_now.selected': 'Affhub Home Hero Join Now Selected',
    }[rfrr];

    return {
      id: rfrr,
      callback: () => {
        if (analytics && typeof analytics.trackEvent === 'function') {
          analytics.trackEvent(rfrr, linkName, null, null, true, [
            getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
          ]);
        }
      },
    };
  };

  return (
    <>
      <UitkFigure src="../images/home/hero.jpg" className="Hero">
        <UitkSpacing padding="six">
          <UitkLayoutFlex
            direction="column"
            className="Hero__contents container"
            justifyContent="center"
            space="four"
            blockSize="full_size"
          >
            <UitkLayoutFlexItem>
              <UitkHeading tag="h1" size={2}>
                <LocalizedText message="home.hero.heading.potential" />
              </UitkHeading>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkText size={400}>
                <LocalizedText message="home.hero.content.generating_revenue" />
              </UitkText>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkLayoutFlex direction="row" space="four">
                <UitkLayoutFlexItem>
                  <AffiliateCTA
                    size={UitkButtonSize.LARGE}
                    analyticsConfig={trackSelect('affhub_home_hero_join_now.selected')}
                  />
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkSecondaryButton
                    analytics={trackSelect('affhub_home_hero_sign_in.selected')}
                    tag={'a'}
                    href={signinLink}
                    data-cy="sign-in-link"
                  >
                    <LocalizedText message="common.sign_in" />
                  </UitkSecondaryButton>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      </UitkFigure>
    </>
  );
}

export { Hero };
